import type { ComponentPropsWithRef } from "react";
import { forwardRef } from "react";
import { TextRenderer } from "@/react/components/shared/BuilderUI/DefaultBlocks/Content/RichText/TextRenderer";
import type { StyleValue } from "@circle-react-shared/BuilderUI/StyleValue.types";
import { parseStyles } from "@circle-react-shared/BuilderUI/utils/parseStyles";
import { classNames } from "../../../utils/twMergeWithCNAndPrefix";
import { defaultStyles } from "./defaultStyles";

interface QuoteProps extends ComponentPropsWithRef<"blockquote"> {
  blockPath: string;
  styles?: Record<string, StyleValue>;
  text: string;
}

/*
  TODO: Replace with Blockquote when having support for the quote styles spec
  https://www.figma.com/design/Nwt1ocYCx3eQg2OZIyUV72/Circle--%3E-Website-Builder--%3E-Templates?node-id=5299-2747&m=dev
*/
export const Quote = forwardRef<HTMLQuoteElement, QuoteProps>(
  ({ text, blockPath, styles = {}, className, ...rest }, ref) => {
    const inlineStyles = parseStyles({ styles, defaultStyles });

    return (
      <blockquote
        ref={ref}
        className={classNames(
          "wb-text-primary wb-font-medium wb-border-l-2 wb-pl-6",
          className,
        )}
        style={inlineStyles}
        {...rest}
      >
        <TextRenderer blockPath={blockPath} text={text} />
      </blockquote>
    );
  },
);

Quote.displayName = "Quote";
